import { useState } from 'react'
import styled, { css } from 'styled-components'

import { Button, PlusIcon } from '@blade/ui-kit'
import { AddWalletTrackerDialog } from '@root/features/wallet-tracker/ui/add-wallet-tracker-dialog'
import { TrackingWalletFollowingUpdatesList } from '@root/features/wallet-tracker/ui/following-updates'
import { WalletAlertsFilters } from '@root/features/wallet-tracker/ui/wallet-alerts-filters'
import { useTranslation } from '@root/shared/localization'
import { PageSection } from '@root/shared/ui-kit'

import type { ClassNameProps } from '@root/shared/react'

type WalletFollowingUpdatesSectionProps = {} & ClassNameProps

export const WalletFollowingUpdatesSection: React.FC<
  WalletFollowingUpdatesSectionProps
> = ({ className }) => {
  const { t } = useTranslation()
  const [addWalletTrackerDialogOpen, setAddWalletTrackerDialogOpen] =
    useState(false)

  const [filtersOpen, setFiltersOpen] = useState(false)

  return (
    <Root className={className}>
      <Header>
        <Title>{t('wallet-tracker.following')}</Title>
        <WalletAlertsFilters open={filtersOpen} onOpenChange={setFiltersOpen} />
        <Button
          onClick={() => setAddWalletTrackerDialogOpen(true)}
          variant="soft"
          radius="rounded"
          size="xxs"
          iconLeft={<PlusIcon size={10} />}
          css={css`
            --button-radius-rounded: 6px;
          `}
        >
          {t('wallet-tracker.add-wallet.button')}
        </Button>
      </Header>
      <TrackingWalletFollowingUpdatesList />
      <AddWalletTrackerDialog
        open={addWalletTrackerDialogOpen}
        onOpenChange={setAddWalletTrackerDialogOpen}
      />
    </Root>
  )
}

const Root = styled(PageSection)`
  min-height: 0;
  height: 100%;

  display: grid;
  grid-template-rows: auto minmax(0, 1fr);
`

const Title = styled.div`
  color: var(--text-12);
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
`

const Header = styled.div`
  display: grid;
  grid-template-columns: 1fr auto auto;
  gap: 8px;

  padding-block: 12px;
  padding-inline: 12px;
  border-bottom: 1px solid var(--background-2);

  align-items: center;
`
